const SYSTEM_TZ = 'Asia/Ulaanbaatar';

function getUserTimezone() {
  try {
    const stored = localStorage.getItem('synoti_user_timezone');
    if (stored) return stored;
  } catch {}
  return SYSTEM_TZ;
}

export function setUserTimezone(tz) {
  try {
    localStorage.setItem('synoti_user_timezone', tz);
  } catch {}
}

export function formatTime(isoString, options = {}) {
  if (!isoString) return '-';
  const tz = options.timezone || getUserTimezone();
  const {
    style = 'full',
    dateOnly = false,
    timeOnly = false,
    relative = false,
  } = options;

  try {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;

    if (relative) {
      return formatRelative(date, tz);
    }

    const locale = options.locale || 'mn-MN';

    if (timeOnly) {
      return date.toLocaleTimeString(locale, { timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit' });
    }
    if (dateOnly) {
      return date.toLocaleDateString(locale, { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' });
    }
    if (style === 'short') {
      return date.toLocaleString(locale, { timeZone: tz, month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    }
    return date.toLocaleString(locale, { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  } catch {
    return isoString;
  }
}

function formatRelative(date, tz) {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  if (seconds < 0) return 'just now';
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return date.toLocaleDateString('mn-MN', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' });
}

export { SYSTEM_TZ, getUserTimezone };
